import React, { useEffect, useState } from "react";
import { Loader2, ChevronUp, ChevronDown } from "lucide-react";
import { brand } from "@/lib/api";

const LABEL = { image: "Image", video: "Video", audio: "Audio", remix: "Remix", blackfx: "Black FX" };
const ago = (iso, now) => { const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000)); return s < 60 ? `${s}s` : `${Math.floor(s / 60)}m ${s % 60}s`; };

// Floating indicator for every running job in the project; jobs keep running while you switch sections.
export default function JobsDock({ jobs, onGo }) {
  const [open, setOpen] = useState(false);
  const [now, setNow] = useState(Date.now());
  useEffect(() => { if (!jobs.length) return undefined; const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, [jobs.length]);
  if (!jobs.length) return null;
  return (
    <div className="fixed bottom-5 right-5 z-50 w-72 rounded-2xl border border-white/10 bg-[#0B1013]/90 backdrop-blur-xl shadow-2xl overflow-hidden" data-testid="jobs-dock">
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid="jobs-dock-toggle" className="w-full flex items-center gap-2.5 px-4 h-12 text-left">
        <Loader2 className="w-4 h-4 animate-spin text-[#5FC0C8]" />
        <span className="flex-1 text-sm font-medium text-white">Processing… <span className="text-zinc-400 font-normal" data-testid="jobs-dock-count">{jobs.length} running</span></span>
        {open ? <ChevronDown className="w-4 h-4 text-zinc-400" /> : <ChevronUp className="w-4 h-4 text-zinc-400" />}
      </button>
      {open && (
        <div className="max-h-72 overflow-y-auto border-t border-white/5 p-1.5" data-testid="jobs-dock-list">
          {jobs.map((g) => (
            <button key={g.id} type="button" onClick={() => onGo(g)} data-testid={`jobs-dock-item-${g.id}`}
              className="w-full text-left p-2 rounded-lg hover:bg-white/5 transition-colors">
              <div className="flex items-center justify-between text-xs"><span className="text-white truncate">{brand(g.model_name)}</span><span className="font-mono text-zinc-500 ml-2">{ago(g.created_at, now)}</span></div>
              <div className="text-[11px] text-zinc-500 truncate">{LABEL[g.section] || g.section} · {g.prompt || "—"}</div>
              <div className="h-0.5 mt-1.5 rounded-full bg-zinc-800 overflow-hidden"><div className="h-full w-1/3 bg-gradient-to-r from-[#7AF25F] to-[#5FC0C8] animate-[axSlide_1.4s_ease-in-out_infinite]" /></div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
